<template>
  <div :class="main_class" @game-clicked="gameClicked(arg)">
    <div style="font-size: 18px; margin: 8px;">{{ currentGame.game }}</div>
    <!-- <div>{{ `Made in ${this.currentGame.year} by:` }}</div> -->
    <div style="margin: 8px; font-size: 14px;">{{ currentGame.description }}</div>
    <div v-if="this.currentGame.company">{{ `Made by ${currentGame.company}. Members:` }}</div>
    <div v-else>{{ `Made by:` }}</div>
    <div class="arrow"></div>
    <div class="members_horizontal">
      <Member v-for="member in this.members" :member="member" :key="member.twitter" :small="true" :swaying="false"/>
    </div>
    <div v-for="(item, index) in this.currentGame.platforms" class="platforms">
      <img :src="`../static/img/${item}.png`"/>
      <a :href="currentGame.urls[index]" target="_blank">{{ platforms[item] }}</a>
    </div>
  </div>
</template>

<script>
  import data from '../data'
  import Member from './Member.vue'
  import { EventBus } from '../EventBus.js'
  
  export default {
    components: {
      Member
    },
    mounted () {
      EventBus.$on('game-clicked', dat => {
        this.visible = true
        this.currentGame = dat['game']
        // this.$el.scrollIntoView()
        // window.scroll(0, this.findPos(this.$el) - 50)
        this.left = dat.left
        this.left = false
        this.members = []
        for (var i = 0; i < data.members.length; i++) {
          if (this.currentGame.authors.indexOf(data.members[i].twitter) >= 0) {
            this.members.push(Object.assign({}, data.members[i]))
          }
        }
      })
      EventBus.$on('game-unclicked', dat => {
        this.visible = false
        this.currentGame = {}
      })
    },
    computed: {
      main_class () {
        var vis = this.visible
        return 'game_info' + (vis ? ' visible' : '') + (this.left ? ' left' : ' right')
      }
    },
    data () {
      return {
        hovering: false,
        members: [],
        platforms: data.platforms,
        left: true,
        visible: false,
        currentGame: {}
      }
    },
    methods: {
      findPos (obj) {
        var curtop = 0
        if (obj.offsetParent) {
          while (obj != null) {
            curtop += obj.offsetTop
            obj = obj.offsetParent
          }
          return [curtop]
        }
      }
    }
  }
</script>


<style>
    .game_info {
        position: fixed;
        width: 450px;
        min-height: 300px;
        left: 50%;
        top: 10%;
        z-index: -1;
        transition: all 100ms ease-in-out;
        opacity: 0;
        background: linear-gradient(#211, #322);
        border-radius: 10px 10px;
        border: 5px solid rgba(221, 90, 13, 1);
        box-shadow: 0px 0px 12px black;
        margin: 20px;
    }
    
    .game_info.visible {
        z-index: 9999;
        opacity: 1.0;
    }
    
    .game_info.right {
        margin-left: 20px;
    }
    
    .game_info.left {
        margin-right: 20px;
    }
    
    .arrow {
        width: 0; 
        height: 0; 
        border-top: 16px solid transparent;
        border-bottom: 16px solid transparent;
        position: absolute;
    }
    
    .game_info.left .arrow {
        border-left: 16px solid rgba(221, 90, 13, 1);
        right: -21px;
    }

    .game_info.right .arrow {
        border-right: 16px solid rgba(221, 90, 13, 1);
        left: -21px;
    }
    
    
    .members_horizontal, .platforms {
        display: flex;
        flex-wrap: wrap;
        max-width: 600px;
        justify-content: center;
    }
    
    .platforms {
        margin-left: 20px;
        justify-content: left;
        align-items: center;
        margin-bottom: 12px;
    }
    
    .platforms img {
        width: 32px;
        height: 32px;
        padding-right: 16px;
    }
    
</style>
<style>
    a {
        color: #dd5a0d;
    }
    a:hover {
        color: #b20e0e;
    }
</style>



// WEBPACK FOOTER //
// src/components/GameInfo.vue